<template>
  <div class="salary-and-work-container">
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SalaryAndWorkIndex'
}
</script>

<style scoped>
.salary-and-work-container {
  padding: 16px;
  background-color: #f8f9fd;
  min-height: calc(100vh - 100px);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>